module.exports = __webpack_public_path__ + "static/media/image_38.34e91ddd.png";